import React from 'react'

const Career = props => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <defs>
      <path
        id="economy_svg__a"
        d="M12.833 3c1.841 0 3.334 1.465 3.334 3.273h2.5c1.84 0 3.333 1.465 3.333 3.272v8.182C22 19.535 20.508 21 18.667 21H5.333C3.493 21 2 19.535 2 17.727V9.545c0-1.807 1.493-3.272 3.333-3.272h2.5C7.833 4.465 9.326 3 11.167 3zm7.5 12.637a3.342 3.342 0 01-1.666.454v3.273c.919 0 1.666-.734 1.666-1.637zM17 16.09H7v3.273h10V16.09zm-13.333-.454v2.09c0 .903.746 1.637 1.666 1.637V16.09c-.61 0-1.175-.173-1.666-.454zm15-7.728H5.333c-.919 0-1.666.734-1.666 1.636v3.273c0 .903.746 1.637 1.666 1.637h13.334c.919 0 1.666-.734 1.666-1.637V9.545c0-.902-.746-1.636-1.666-1.636zm-5.834 3.273c.459 0 .834.368.834.818 0 .45-.375.818-.834.818h-1.666a.828.828 0 01-.834-.818c0-.45.375-.818.834-.818zm0-6.546h-1.666c-.92 0-1.667.734-1.667 1.637h5c0-.903-.748-1.637-1.667-1.637z"
      />
    </defs>
    <use fill={props.fill || '#1A344F'} fillRule="nonzero" xlinkHref="#economy_svg__a" />
  </svg>
)

export default Career
